import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import { Asset } from 'src/types/schema/graphql'
import HeroImage from '../components/HeroImage'
import SingleColImage from '../components/SingleColImage'

interface IThreeImageLayout {
    assets: Asset[]
    imageClasses: string
}

const ThreeImageLayout: React.FC<IThreeImageLayout> = ({ assets, imageClasses }) => {
    return (
        <>
            <HeroImage asset={assets[0]} imageClasses={imageClasses} />
            {assets?.map((asset, index) => {
                if (index > 0) {
                    return <SingleColImage key={index} asset={asset} />
                }
            })}
        </>
    )
}
export default ThreeImageLayout
